<template>
    <div>
    </div>
</template>
<script>
import { mapActions,mapGetters } from 'vuex';

export default {
    props:['venta','tipo'],
    data()
    {
        return {
            formatoImpresion:'tirilla',
            enviarVenta:{
                email:'',
                venta:'',
                formato:'',
                tipo:'',
            }
        }
    },
    computed:{
        ...mapGetters({
            totalesStore: posCartTypes.getters.totales,
        }),
        esSimplificado()
        {
            return this.venta ? this.venta.tienda.regimen.iva==0 : false;
        },
        totales()
        {
            return this.totalesStore(this.venta.productos,(this.venta ? this.venta.tienda.regimen : null),this.tipo);
        },
        deshabilitar()
        {
            return this.loadingMessage || this.successMessage.length>0
        },
        tienda()
        {
            if(Object.keys(this.venta).length==0)
            {
                return null;
            }
            return this.venta.tienda;
        }
    },
    methods:{
        ...mapActions({
            sendVentaStore: ventasTypes.actions.enviarVenta
        }),
        sendEmail()
        {
            this.enviarVenta.venta = this.venta.id;
            this.enviarVenta.tipo = this.tipo;

            this.$validator.validateAll()
            .then(result => {
                if(result)
                {
                    this.enviarVenta.formato = this.formatoImpresion;
                    this.executeAlert();
                    this.sendVentaStore(this.enviarVenta)
                    .then(response => {
                        this.responseAlert(response,true);
                        if(response.data.success)
                        {
                            $('.modal').modal('hide');
                        }
                    })
                    .catch(e => {
                        this.errorAlert();
                    });
                }
            })
                
        },
        plantillaCSS()
        {
            return (this.formatoImpresion=='tirilla' ? '' : '<link href="//maxcdn.bootstrapcdn.com/bootstrap/4.1.1/css/bootstrap.min.css" rel="stylesheet" id="bootstrap-css">')+`
                    <style>
                        @page 
                        {
                            size:  auto;   /* auto is the initial value */
                            margin: 0;  /* this affects the margin in the printer settings */
                        }

                        html
                        {
                            background-color: #FFFFFF; 
                            margin: 0px;
                            font-size:4mm;
                        }
                        h3{
                            margin:0;
                        }
                        .nameProducto
                        {
                            font-size:`+(this.formatoImpresion=='tirilla' ? '0.85rem' : '0.9rem')+`;
                        }
                        .container-factura{
                            width:100%;
                            max-width:`+(this.formatoImpresion=='tirilla' ? 76 : 216)+`mm;
                            padding:`+(this.formatoImpresion=='tirilla' ? '10mm 4mm' : '10mm 10mm 10mm 20mm')+`;
                        }
                        .text-anulada{
                            font-size: `+(this.formatoImpresion=='tirilla' ? '3.5rem' : '7rem')+`;
                            color: rgba(244, 67, 54, 0.7);
                            transform: rotate(-45deg);
                            z-index: 5;
                            font-weight: bold;
                            position: absolute;
                        }
                        .bold{
                            font-weight:bold
                        }
                        .total
                        {
                            font-size:`+(this.formatoImpresion=='tirilla' ? '1.2rem' : '1.5rem')+`;
                        }
                        hr
                        {
                            margin:1mm;
                            border:none;
                            border-top:1px dashed #000;
                        }
                        table th, table tr td{
                            border:none;
                            padding:0.5mm 0;
                            border-collapse: collapse;
                        }
                        .table-times{
                            table-layout: fixed !important;
                            width:100% !important;
                            max-width:`+(this.formatoImpresion=='tirilla' ? 74 : 210)+`mm !important;
                        }
                        table.table-items, table.table-items th, table.table-items td {
                            border: 1px solid black;
                            border-collapse: collapse;
                        }
                        .container-table-items
                        {
                            width:100%;
                            padding:0;
                        }
                        table.table-items tr th,table.table-items tr td
                        {
                            font-size:`+(this.formatoImpresion=='tirilla' ? '0.85rem' : '0.9rem')+`;
                        }
                        table.table-items td:last-child{
                            text-align:right;
                        }
                        th, td {padding: 0.5mm 0;text-align: left;}

                        .imgCenter {
                            display: block;
                            margin-left: auto;
                            margin-right: auto;
                            max-width:60mm;
                            max-height:30mm;
                        }                    
                        .resolucion{font-size:0.95rem;}
                        .centerText { text-align: center}
                        .rightText { text-align: right}
                        .boldText {font-weight: bold;}
                        h3{margin-top:0;}
                    </style>`;
        },
        getPlantilla()
        {
            return this.plantillaCSS()+this.$refs.contenedorImpresion.innerHTML;
        },
        print()
        {
            var plantilla = this.getPlantilla();
            $('<iframe>', {name: 'myiframe',class: 'printFrame'})
            .appendTo('body')
            .contents().find('body')
            .append(plantilla);

            window.frames['myiframe'].focus();
            window.frames['myiframe'].print();

            setTimeout(() => { $(".printFrame").remove(); }, 1000);
        },
    },
    mounted()
    {
        if(this.tipo && this.tipo=='notaCredito')
        {
            this.formatoImpresion = 'carta';
        }
    }
}
</script>
<style lang="stylus" scoped>
#contenedor-impresion
    overflow-y scroll
    overflow-x hidden
    height auto
    max-height 50rem
    max-width 100% !important
    position relative
#contenedor-impresion::-webkit-scrollbar
    width 6px
    background-color #F5F5F5
#contenedor-impresion::-webkit-scrollbar-thumb
    background-color #bdbdbd
.text-anulada
    font-size 6rem
    color rgba(244, 67, 54, 0.7)
    transform: rotate(-45deg);
    z-index 5
    font-weight bold
    position absolute
</style>
